import React, {useState} from "react";

export function useMediaQuery(query) {
    const [matches, setMatches] = useState(window.matchMedia(query).matches);

    React.useEffect(() => {
      const matchQueryList = window.matchMedia(query);
      function handleChange(e) {
        setMatches(e.matches);
      }
      matchQueryList.addEventListener("change", handleChange);

      return () => {
        matchQueryList.removeEventListener("change", handleChange);
      };
    }, [query]);

    return matches;
  }


  export function htmlToPlainText(html) {
  if (!html) return "";
  // Replace <br> and <br/> with newlines
  let text = html.replace(/<br\s*\/?>/gi, "\n");
  // Replace block-level tags with newlines
  text = text.replace(/<\/(h[1-6]|p|div|li|ul|ol|strong|em|u|b|i)>/gi, "\n");
  // Remove all other HTML tags
  text = text.replace(/<[^>]+>/g, "");
  // Replace multiple newlines with a single newline
  text = text.replace(/\n{2,}/g, "\n");
  return text.trim();
}

export const plainTextToHtml = (text) => {
  return text.split('\n').map(line => `<p>${line}</p>`).join('');
};